import { useEffect, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
	BaseForm,
	ButtonCancel,
	ButtonSave,
	FormGroup,
	ModalBody,
	ModalDraggable,
	ModalFooter,
	ModalHeader,
	SwitchBox,
	TextAreaBox,
	TextBox,
} from '../../../../components/base';
import { RoleModel, df_RoleModel, valid_RoleModel } from '../../../../context/models/roles/RoleModel';
import { CheckedBoxListRoleScope } from '../../../../components/shared/system';

type IRoleDetailModalProps = {
	isShow: boolean;
	title: string;
	detailModel?: RoleModel;
	isSaving: boolean | false;
	onClose: () => void;
	onSubmit: (data: RoleModel) => void;
};

const RoleDetailModal = (props: IRoleDetailModalProps) => {
	const { isShow, title, detailModel, onSubmit, onClose, isSaving } = props;
	const isAddMode = !detailModel;
	const [initialValues, setInitialValues] = useState<RoleModel>(df_RoleModel);

	const {
		handleSubmit,
		reset,
		formState: { errors },
	} = useForm<RoleModel>({
		resolver: yupResolver(valid_RoleModel()),
		mode: 'all',
		defaultValues: initialValues,
	});

	const onSubmitHandler = (values: RoleModel) => {
		onSubmit(values);
	};

	useEffect(() => {
		if (initialValues) {
			reset(initialValues);
		}
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [initialValues, reset]);

	useEffect(() => {
		if (detailModel) {
			const { id, name, description, isActive, isProtected, roleScopeIds } = detailModel;
			setInitialValues((prev) => ({ ...prev, id, name, description, isActive, isProtected, roleScopeIds }));
		}
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [detailModel]);

	return (
		<>
			<ModalDraggable show={isShow} sizeClass='sm' type='primary' onClose={onClose}>
				<ModalHeader classDragg={true} title={title} onClose={() => onClose()} />
				<ModalBody>
					<BaseForm onSubmit={handleSubmit(onSubmitHandler)}>
						<TextBox
							name={'name'}
							error={errors.name?.message}
							onValueChanged={(value) => {
								setInitialValues((prev) => ({ ...prev, name: value }));
							}}
							value={initialValues.name}
							hasValid={true}
							label='Tên tác nhân'
						/>
						<TextAreaBox
							name={'description'}
							error={errors.description?.message}
							onValueChanged={(value) => {
								setInitialValues((prev) => ({ ...prev, description: value }));
							}}
							value={initialValues.description}
							hasValid={true}
							label='Mô tả'
						/>
						<CheckedBoxListRoleScope
							name='roleScopeIds'
							label='Quyền hạn'
							hasValid={true}
							error={errors.roleScopeIds?.message}
							selectedValue={initialValues.roleScopeIds}
							onSelectionChanged={(value: any[]) => {
								setInitialValues((prev) => ({ ...prev, roleScopeIds: value?.map((x) => parseInt(x)) }));
							}}
						/>
						<FormGroup label='Trạng thái'>
							<SwitchBox
								name='isActive'
								label='Áp dụng'
								error={errors.isActive?.message}
								onValueChanged={(value) => {
									setInitialValues((prev) => ({ ...prev, isActive: value }));
								}}
								value={initialValues.isActive}
								sizeClass='sm'
							/>
							<SwitchBox
								name='isProtected'
								label='Không sửa đổi'
								error={errors.isProtected?.message}
								onValueChanged={(value) => {
									setInitialValues((prev) => ({ ...prev, isProtected: value }));
								}}
								value={initialValues.isProtected}
								sizeClass='sm'
							/>
						</FormGroup>
					</BaseForm>
				</ModalBody>
				<ModalFooter>
					<ButtonCancel onClick={onClose} isDisabled={isSaving} />
					<ButtonSave
						type='button'
						isLoading={isSaving}
						isDisabled={isSaving}
						onClick={handleSubmit(onSubmitHandler)}
						text={`${!isAddMode ? 'Cập nhật' : 'Thêm mới'}`}
					/>
				</ModalFooter>
			</ModalDraggable>
		</>
	);
};

export default RoleDetailModal;
